<template>
  <div class="mt-2">
    <div class="container">
      <div class="row">
        <reciepeListElement
          v-for="reciepe in reciepes"
          :name="reciepe.name"
          :key="reciepe.id"
          :description="reciepe.description"
          @goToReciepe="goToReciepe"
        ></reciepeListElement>
      </div>
      <button
        class="btn btn-secondary"
        v-if="isLoggedIn && !add_reciepe"
        @click="add_reciepe = true"
      >
        Legg til ny oppskrift
      </button>
      <button
        class="btn btn-secondary"
        v-if="isLoggedIn && add_reciepe"
        @click="add_reciepe = false"
      >
        Fjern skjema
      </button>
      <editReciepeForm
        v-if="add_reciepe"
        @posted="loadReciepes"
      ></editReciepeForm>

      <p v-if="message">{{ message }}</p>
    </div>
  </div>
</template>
<script>
import reciepeListElement from "@/components/reciepeListElement.vue";
import editReciepeForm from "@/components/editReciepeForm.vue";

export default {
  name: "ReciepeList",
  data: function() {
    return {
      reciepes: null,
      message: null,
      active_id: null,
      active_description: null,
      active_ingredients: null,
      active_directions: null,
      isLoggedIn: this.$session.has("token"),
      add_reciepe: false
    };
  },
  computed: {
    ingredient_list() {
      var res = [];
      for (var i = 1; i < this.ingredient_amounts.length; i += 1) {
        res.push({
          amount: this.ingredient_amounts[i],
          name: this.ingredient_names[i],
          unit: this.ingredient_units[i]
        });
      }
      return res;
    }
  },
  mounted() {
    this.loadReciepes();
  },
  components: {
    reciepeListElement,
    editReciepeForm
  },
  methods: {
    loadReciepes() {
      this.message = "";
      this.APIget("reciepes/all/?format=json").then(response => {
        if (!response.error) this.reciepes = response.data;
        else this.message = response.error;
      });
    },
    expandDescription(key) {
      this.active_id = this.active_id == key ? null : key;
      /*this.APIget("reciepes/" + key + "/?format=json").then(response => {
        if (response.error) {
          this.active_description =
            "Error occured while retrieving reciepe" + response.error;
          return;
        }
        this.active_id = key;
        this.active_description = response.data.description;
        if (response.data.ingredients)
          this.active_ingredients = response.data.ingredients;
        this.active_directions = response.data.directions;
      });*/
    },
    changeLoginStatus(new_status) {
      this.isLoggedIn = new_status;
    },
    goToReciepe(id) {
      this.$router.push(`/reciepe/${id}`);
    }
  }
};
</script>
